import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicesPage from "../pages/services/page";
import GalleryPage from "../pages/gallery/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/gallery",
    element: <GalleryPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
